export const LOGIN = 'inloggen';
export const CHANGE_CREDENTIALS = 'inloggegevens';
export const FORGOT_BROWSERCODE = 'browsercode-vergeten';
export const ERROR = 'error';

export const WUP_EVENTS_ACTIVE = 'mijn-omgeving.wup-events-ui';
